// utils/teamParam.js
export function getTeamParamFromUrl() {
    try {
        const params = new URLSearchParams(window.location.search);
        const val = params.get('team'); // string or null
        return val && val.trim() !== '' ? val : null;
    } catch (e) {
        return null;
    }
}
